// these sizes are arbitrary and you can set them to whatever you wish
const defaulttheme = {
  // Header landing section
  headerTextColor: 'white',

  // Button constants
  buttonTextColor: 'white',
  buttonBorderRadius: '4px',
  filledButtonBGColor: '#19c7ff',
  transparentButtonBGColor: 'rgba(255, 255, 255, 0.1)',
  transparentButtonBorder: 'solid 1px rgba(255, 255, 255, 0.4);',

  // darkBGColor: 'linear-gradient(#119ef7,#112e7e)',
  navbar: {
    lightBGColor: '#fffff',
    darkBGColor: '#ffffff',
    navTextColor: '#0a3981',
    transparentNavTextColor: '#0a3981',
    bgColor: '#fff',
    transparentBGColor: 'transparent'
  },
  reachingWorldWide: {
    headingColor: `#43484d`,
    subHeadingColor: `#5e6977`,
    descriptionColor: `#86939e`,
    applyColor: `#358ed7`
  },
  footerSection: {
    background: `#122445`,
    inputBackground: `rgba(255, 255, 255, 0.1)`,
    inputText: `#ffffff`,
    lightTextColor: `#ffffff`,
    filledButtonBGColor: '#19c7ff',
    pageLinksColor: `#ffffff`,
    poweredByTextColor: '#43484d',
    poweredbyBackgroundColor: '#ffffff',
    poweredbyDivider: 'none',
    white: `#ffffff`
  }
}
export default defaulttheme



// WEBPACK FOOTER //
// ./src/constants/themeConstants/whiteTheme.js